<ng-container *ngIf="paymentInfo">
  <box class="payment-history-trx-item">
    <box class="trx-icon">
      <div class="biller-photo">
        <ng-container *ngIf="paymentInfo.icon; else noPhoto">
          <img *ngIf="paymentInfo.icon; else noPhoto" [src]="'./assets/images/bill-payment/'+paymentInfo.icon" />
        </ng-container>
        <ng-template #noPhoto>
          <div class="biller-letter-name">
            <ng-container *ngIf="paymentInfo.description; else noName">
              <span *ngIf="paymentInfo.description?.split(' ').length == 1">{{paymentInfo.description?.substring(0, 1)}}
              </span>
              <span *ngIf="paymentInfo.description?.split(' ').length > 1 && paymentInfo.description?.split(' ').length != 1">
                {{paymentInfo.description?.split(" ")[0]?.charAt(0) +(paymentInfo.description?.split(" ")[1]? paymentInfo.description?.split(" ")[1]?.charAt(0): "")}}
              </span>
            </ng-container>
            <ng-template #noName>
            <span>  {{ paymentInfo.description?paymentInfo.description:'U' }}
            </span>
              </ng-template>

          </div>
        </ng-template>
      </div>
        <!-- {{ item.description?.charAt(0).toUpperCase() }} -->
    </box>
    <box class="trx-details">
        <box class="trx-primary-info">
            <span class="date">{{ paymentInfo.paymentDate | date :'dd/MM/yyyy' }}</span>
            <span class="title">{{ paymentInfo.description?paymentInfo.description:'Unknown' }}</span>
            <span class="description">
              <ng-container *ngIf="paymentInfo.status; else noStatus">
              <span *ngIf="paymentInfo.status=='S'"class="success" >Successful</span>
              <span *ngIf="paymentInfo.status=='F'" class="fail">Declined</span>
            </ng-container>
              <ng-template #noStatus>
                <!-- <span class="initiated">Initiated</span> -->
              </ng-template>
            </span>
        </box>
        <box class="trx-secondary-info">
          <span class="payment-amount">
              <span class="amount">
                {{ commonService.formatAmount(paymentInfo.paymentAmount) }}
              </span>
              <span class="currency">
                {{paymentInfo.currency}}
              </span>
            </span>

        </box>
    </box>
  </box>
  <div class="payment-details-header">Payment Details</div>
  <box class="bill-payment-info">
      <span class="info-lbl">Payment date</span>
      <span class="info-val">{{ paymentInfo.paymentDate }}</span>
  </box>

  <box class="bill-payment-info">
    <span class="info-lbl">Reference no.</span>
    <span class="info-val">{{ paymentInfo.tranRef }}</span>
</box>
</ng-container>
